import React, { useEffect, useState } from "react";
import { Form, Button, Tabs, Space, Card, message } from "antd";
import { API_METHODS, BLANK_VALUE } from "../helpers/constant";
import useApi from "../helpers/useApi";
import TableComponent from "../helpers/TableComponent";

function Buyer() {
  const [activeTab, setActiveTab] = useState(1);

  const columns = [
    // {
    //   title: "Name",
    //   dataIndex: "name",
    // },
    {
      title: "Mobile",
      dataIndex: "mobile",
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    // },

    // {
    //   title: "Action",
    //   key: "action",
    //   render: (text, record) => (
    //     <>
    //       {
    //         <Space>
    //           <Popconfirm
    //             title="Delete Video"
    //             description={`Are you sure to delete this Video?`}
    //             onConfirm={() => deleteOk(record)}
    //             trigger={"click"}
    //             okButtonProps={{
    //               loading: confirmDeletePCLoading,
    //             }}
    //             placement="rightTop"
    //           >
    //             <Button size="small">
    //               <DeleteOutlined style={{ color: "red" }} />
    //             </Button>
    //           </Popconfirm>
    //         </Space>
    //       }
    //     </>
    //   ),
    // },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/buyers?pageNumber=1`,
    null,
    API_METHODS.GET
  );

  const [tableData, setTableData] = useState();
  const [form] = Form.useForm();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  const onPaginationChange = (page) => {
    setCurrentPage(page.current);
    if (activeTab == 1) {
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/buyers?pageNumber=${page.current}`
      );
    }
    if (activeTab == 2) {
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/buyers/payment-not-done?pageNumber=${page.current}`
      );
    }
  };

  const onTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
    form.resetFields();
    if (key == 1) {
      getRequest(null, API_METHODS.GET, `/admin/buyers?pageNumber=1`);
    }
    if (key == 2) {
      getRequest(
        null,
        API_METHODS.GET,
        `/admin/buyers/payment-not-done?pageNumber=1`
      );
    }
  };

  const items = [
    {
      key: 1,
      label: "Buyers",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: 2,
      label: "Payment Not Done",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
  ];

  return (
    <Card title="Buyers">
      {contextHolder}
      <Tabs activeKey={activeTab} items={items} onChange={onTabChange} />
    </Card>
  );
}

export default Buyer;
